import { useQuery } from '@tanstack/react-query'
import { fetchPlans } from 'utility/queries/plans'
import { useGroup } from 'components/providers/GroupProvider'
import { useRouter } from 'next/router'

export const usePlans = ({ groupId }) => {
	const { group } = useGroup()
	const router = useRouter()

	const partnerSlug = router?.query?.slug
	const finalGroupId = groupId || group?.data?.groupId

	return useQuery({
		enabled: true,
		queryKey: ['plans', finalGroupId, partnerSlug],
		queryFn: () => fetchPlans({ groupId: finalGroupId, partnerSlug }),
	})
}
